import { render, staticRenderFns } from "./AlignBottomRight.vue?vue&type=template&id=1b72798c&scoped=true&"
import script from "./AlignBottomRight.vue?vue&type=script&lang=js&"
export * from "./AlignBottomRight.vue?vue&type=script&lang=js&"
import style0 from "./AlignBottomRight.vue?vue&type=style&index=0&id=1b72798c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72798c",
  null
  
)

export default component.exports